<template>
        <div>
            <div class="row bottom-padding">
                <div class="title-box">
                    <h1 class="title">Welcome to Girish Jewellers</h1>
                </div>
                
                <div class="bottom-padding-mobile">
                    <p class="lead"><strong>Girish Jewellers</strong> is a gold jewellery manufacturing house; that think about the he younger generation and the reasons behind their purchase - designing timeless pieces that will lonve buyers awe. struck and mesmerised with its sparkling beauty. This contemporary brand has its legacies firmly in another time - and another world. Our prime focus lies in delivering youth-centri jewellery designs that are appealing and exclusive.</p>
                    <p class="lead">we have an in-house manufacturing et-up that gives birth to eye-catching gold ewellery. From start to finish, the gold jewellery s curated in-house, crafted by skilled workers and backed by gem industry specialists all under One roof. Moreover, we utilize latest machinery and advanced technology that helps us maintain highest production quality.

</p>
                    <router-link to="/about" class="btn">Read more</router-link>
                </div>
                
                </div>
                <div class="carousel-box bottom-padding load">
            <div class="clearfix"></div>
        </div>
    </div>
</template>    
<script>
export default {
  name: 'WhoWeAre',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
